import React from 'react';
import { Box, Typography, Alert } from '@mui/material';

const ErrorState = ({
  title = 'Something went wrong',
  description = 'Please try again in a moment.',
  details,
  action,
}) => {
  return (
    <Box
      sx={{
        py: 6,
        px: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 2,
      }}
    >
      <Alert severity="error" sx={{ width: '100%', maxWidth: 760 }}>
        <Typography variant="h6" sx={{ fontWeight: 800, mb: 0.5 }}>
          {title}
        </Typography>
        <Typography variant="body2">{description}</Typography>
        {details ? (
          <Typography variant="caption" sx={{ display: 'block', mt: 1, opacity: 0.8 }}>
            {details}
          </Typography>
        ) : null}
        {action ? (
          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>{action}</Box>
        ) : null}
      </Alert>
    </Box>
  );
};

export default ErrorState;

